import React from "react";
import TooltippedElement from "components/TooltippedElement";
import { GrRefresh } from "react-icons/gr";
import qbIcon from "images/icons/quickbooks/qb.svg"
import qbErrorIcon from "images/icons/quickbooks/qbRed.svg"
import qbInfoIcon from "images/icons/quickbooks/qbBlue.svg"
import TTax from "../types/TTax";
import TTaxGroup from "../types/TTaxGroup";

type Props = {
  tax: TTax | TTaxGroup;
  animatingTaxId: string | null;
  syncTax: ((id: string) => void) | ((taxGroup: TTaxGroup) => void);
  syncTaxLoading: boolean;
  syncingTaxId: string | null;
  group?: boolean;
  currentSyncingGroup?: TTaxGroup | null;
};

const SyncTax = (props: Props) => {
  const { tax, animatingTaxId, syncTax, syncTaxLoading, syncingTaxId, group, currentSyncingGroup } = props;

  const handleSync = () => {
    if (group) {
      (syncTax as (taxGroup: TTaxGroup) => void)(tax as TTaxGroup);
    } else {
      (syncTax as (id: string) => void)(tax.id?.toString() ?? "");
    }
  };

  const toolTipMessage = () => {
    let message = "";
    if (group) {
      message = tax.qbol_id && tax.qbol_synced_at
        ? "Group synced to Quickbooks"
        : !tax.qbol_id && tax.qbol_message
        ? `Group ${tax.qbol_message.charAt(0).toLowerCase() + tax.qbol_message.slice(1)}` // make first letter of message lowercase
        : "Group not synced to Quickbooks";
    } else {
      message = tax.qbol_id && tax.qbol_synced_at
        ? "Synced to Quickbooks"
        : !tax.qbol_id && tax.qbol_message
        ? tax.qbol_message
        : "Not synced to Quickbooks";
    }
    return message;
  };

  if (!group && "tax_type" in tax && tax.tax_type !== "tax") return null;

  const idStr = tax.id?.toString() ?? "";

  // ✅ True if this exact item is being synced (single-tax or the group itself)
  const selfIsSyncTarget = syncTaxLoading && syncingTaxId === idStr;

  // ✅ True if there is a group currently syncing and THIS item is that group OR inside it
  const inCurrentSyncingGroup =
    !!currentSyncingGroup &&
    (
      currentSyncingGroup.id?.toString() === idStr ||
      currentSyncingGroup.taxes.some((t) => t.id?.toString() === idStr)
    );

  const isSpinning = selfIsSyncTarget || inCurrentSyncingGroup;

  return (
    <div>
      <div className="flex items-center space-x-3">
        <TooltippedElement
          message={toolTipMessage()}
          className={`${
            animatingTaxId === tax.id?.toString() ? "animate-emphasis" : ""
          }`}
          element={
            tax.qbol_id && tax.qbol_synced_at ? (
              <img src={qbIcon} alt="Quickbooks" className="w-5 h-5" />
            ) : !tax.qbol_id && tax.qbol_message ? (
              <img src={qbErrorIcon} alt="Quickbooks" className="w-5 h-5" />
            ) : (
              <img src={qbInfoIcon} alt="Quickbooks" className="w-5 h-5" />
            )
          }
        />
        <button
          onClick={handleSync}
          className={`${
            isSpinning ? "animate-spin" : ""
          }`}
        >
          <GrRefresh className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default SyncTax;
